import { Box, Typography, Button, Modal } from '@mui/material';

type ActionModalProps = {
  title: string;
  onDismiss: () => void;
  onSubmit: () => void;
  text: string | undefined;
  actionText: string;
  isModalVisible: boolean;
  isSubmitting: boolean;
};

export const ActionModal = ({
  title,
  text,
  onDismiss,
  onSubmit,
  actionText,
  isModalVisible,
  isSubmitting,
}: ActionModalProps) => {
  return (
    <Modal open={isModalVisible} onClose={onDismiss}>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          boxShadow:
            '0px 0px 1px #EAECF0, 0px 32px 64px -12px rgba(29, 41, 57, 0.08)',
          borderRadius: '4px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: {
            xs: 326,
            md: 600,
          },
        }}
      >
        <Box className="width-full p-8 flex">
          <Typography variant="h4" data-testid="actionModalTitle">
            {title}
          </Typography>
        </Box>
        {text && (
          <Box
            className="width-full px-8 py-2 flex"
            data-testid="actionModalText"
          >
            <Typography>{text}</Typography>
          </Box>
        )}
        <Box className="width-full p-8 flex justify-end gap-4">
          <Button
            variant="text"
            onClick={onDismiss}
            className="text-gray-1"
            disabled={isSubmitting}
          >
            Dismiss
          </Button>
          <Button
            onClick={onSubmit}
            className="bg-red-1 text-white hover:text-inherit"
            disabled={isSubmitting}
            data-testid="actionModalActionText"
          >
            {actionText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
